export default __webpack_public_path__ + "static/media/mark_4.40daf77d.png";